import TeamItem from "./TeamItem";
import Grid from '@mui/material/Grid2';
function TeamList(props) {
  return (
    <Grid container spacing={props.minimalMode ? 1 : 2}>
      {Object.entries(props.teamList).map(([key, value]) => {
        return (
          <Grid size={{xs:6}} key={key}>
              <TeamItem
                id={key}
                managerMode={props.managerMode}
                players={value}
                chukkerId={props.chukkerId}
                referencePlayer={props.referencePlayer}
                useUSPARating={props.useUSPARating}
                isBench={props.isBench}
                proColorMapping={props.proColorMapping}
                betaMode={props.betaMode}
                chukkerDetails={props.chukkerDetails}
                setChukkerDetails={props.setChukkerDetails}
                useEnhancedPlayerList={props.useEnhancedPlayerList}
                onQuickAssign={props.onQuickAssign}
                getAvailableTargets={props.getAvailableTargets}
                minimalMode={props.minimalMode}
              />
              </Grid>
        );
      })}
    </Grid>
  );
}

export default TeamList;
